function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9032 1H4.09677C2.38647 1 1 2.3674 1 4.05417V21.9458C1 23.6326 2.38647 25 4.09677 25H21.9032C23.6135 25 25 23.6326 25 21.9458V4.05417C25 2.3674 23.6135 1 21.9032 1Z",
  stroke: "#899296"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 6C16.8598 6 20 9.097 20 12.9037C20 16.7104 16.8598 19.8074 13 19.8074C9.1402 19.8074 6 16.7104 6 12.9037C6 9.097 9.1402 6 13 6ZM13 7.03555C9.7191 7.03555 7.05 9.66793 7.05 12.9037C7.05 14.3259 7.5659 15.632 8.4227 16.649L16.8101 8.39973C15.7769 7.5485 14.4483 7.03555 13 7.03555ZM13 18.7718C16.2809 18.7718 18.95 16.1395 18.95 12.9037C18.95 11.5071 18.4523 10.2223 17.6228 9.21367L9.24591 17.4532C10.2707 18.2775 11.5776 18.7718 13 18.7718Z",
  fill: "#899296"
});

var SvgIconButtonBan = function SvgIconButtonBan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconButtonBan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_button_ban.e6c73546.svg";
export { ForwardRef as ReactComponent };